import {
  BanknotesIcon,
  Cog6ToothIcon,
  HomeIcon,
  ShoppingBagIcon,
  ShoppingCartIcon,
  ArrowDownTrayIcon,
  UserGroupIcon,
  TruckIcon,
} from "@heroicons/react/24/outline";
import type { ComponentType, SVGProps } from "react";

export interface NavigationChild {
  name: string;
  href: string;
  current: boolean;
}

export interface NavigationRoute {
  name: string;
  href?: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  current: boolean;
  showInMenu: boolean;
  section: string;
  open?: boolean;
  children?: NavigationChild[];
}

export interface NavigationResult {
  routes: NavigationRoute[];
  title?: string;
}

const isCurrentPath = (href: string, pathname: string): boolean =>
  pathname === href || (href !== "/" && pathname.startsWith(`${href}/`));

export default function routes(pathname: string, userType: number): NavigationResult {
  let title: string | undefined;
  let routes: NavigationRoute[];

  routes = [
    {
      name: "Dashboard",
      href: "/dashboard",
      icon: HomeIcon,
      current: false,
      showInMenu: true,
      section: "Home",
    },
    {
      name: "Receiving",
      href: "/receiving",
      icon: ArrowDownTrayIcon,
      current: false,
      showInMenu: true,
      section: "Inbound",
    },
    {
      name: "Orders",
      href: "/orders",
      icon: ShoppingCartIcon,
      current: false,
      showInMenu: true,
      section: "Outbound",
    },
    {
      name: "Shipments",
      href: "/shippings",
      icon: TruckIcon,
      current: false,
      showInMenu: true,
      section: "Outbound",
    },
    {
      name: "Customers",
      icon: UserGroupIcon,
      current: false,
      showInMenu: true,
      section: "Catalog",
      children: [
        { name: "Manage Customers", href: "/customers", current: false },
        { name: "Manage Groups", href: "/customer-groups", current: false },
      ],
    },
    {
      name: "Products",
      icon: ShoppingBagIcon,
      current: false,
      showInMenu: true,
      open: false,
      section: "Catalog",
      children: [
        { name: "Manage Products", href: "/products", current: false },
        ...(userType === 1 ? [{ name: "Imports", href: "/products/imports", current: false }] : []),
        { name: "Primary Categories", href: "/primary-categories", current: false },
        { name: "Sub Categories", href: "/sub-categories", current: false },
      ],
    },
    {
      name: "Expenses",
      icon: BanknotesIcon,
      current: false,
      showInMenu: true,
      open: false,
      section: "Expenses",
      children: [{ name: "Manage Expenses", href: "/expenses", current: false }],
    },
    {
      name: "Setup",
      icon: Cog6ToothIcon,
      current: false,
      showInMenu: userType === 1,
      open: false,
      section: "Setup",
      children: [
        { name: "Company Settings", href: "/account/company-settings", current: false },
        { name: "Quickbooks", href: "/quickbooks-login", current: false },
        { name: "Suppliers", href: "/suppliers", current: false },
        { name: "Tax Rates", href: "/tax-rates", current: false },
        { name: "Users", href: "/users", current: false },
        { name: "Warehouses", href: "/warehouses", current: false },
      ],
    },
  ];

  routes.forEach((route) => {
    route.open = false;
    if (route.children) {
      route.children.forEach((child) => {
        const moreSpecificChildMatches = route.children?.some(
          (candidate) =>
            candidate.href.length > child.href.length && isCurrentPath(candidate.href, pathname)
        );
        child.current = isCurrentPath(child.href, pathname) && !moreSpecificChildMatches;
        if (child.current) {
          route.open = true;
          title = child.name;
        }
      });
    } else if (
      (route.href !== undefined && isCurrentPath(route.href, pathname)) ||
      (route.href === "/orders" && pathname === "/create-order")
    ) {
      route.current = true;

      title = route.name;
    }
  });

  var returnArray = {
    routes: routes.filter((route) => route.showInMenu),
    title: title,
  };

  return returnArray;
}
